import React, { Suspense, useEffect, useState } from "react";
import { Provider } from "react-redux";
import {
  Link,
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import io from "socket.io-client";
// defaults to localStorage for web
import { Theme247 } from "./styles/Theme247";

import { CssBaseline, Typography } from "@mui/material";
import { config_UPTIME } from "./Constants";
import { GlobalCss } from "./styles/GlobalCss";
import { applyAccountTheme, getDualRoutePath } from "./utils/accountMode";
import { useSelector } from "react-redux";

import MachineOverviewPage from "./pages/MachineOverviewPage/MachineOverviewPage";
import NotificationDetailsPage from "./pages/NotificationDetailsPage/NotificationDetailsPage";

import ProfilePage from "./pages/ProfilePage/ProfilePage";

import store from "./store";
import InitialState from "./pages/NewDashboardPage/component/InitialState";
import CreateSite from "./pages/CreateSite";
import CreateEquipment from "./pages/CreateEquipment";
import CreateArea from "./pages/CreateArea";
import CreateEquipmentPool from "./pages/CreateEquipmentPool";
import Users from "./pages/Users/Users";

import OrderSubscriptionPage from "./pages/OrderSubscriptionPage/OrderSubscriptionPage";
import OrderSubscriptionStep2 from "./pages/OrderSubscriptionPage/OrderSubscriptionStep2";
import OrderSubscriptionStep3 from "./pages/OrderSubscriptionPage/OrderSubscriptionStep3";
import SignUpPage from "./pages/SignUpPage/SignUpPage";
import HelpAndFeedbackPage from "./pages/HelpAndFeedbackPage/HelpAndFeedbackPage";
import {
  clearLocalStoragePreservingLanguage,
  getItem,
  setItem,
} from "./utils/DataProtection";
import TemplateSkeliton from "./pages/MachineOverviewPage/_tabs/Maintenance/components/TemplateSkeliton";
import AufgabePlanung from "./pages/AufgabePlanung";
import KundenDashboard from "./pages/KundenDashboard/KundenDashboard";
import KundenPortal from "./pages/KundenPortal/KundenPortal";
import KundenStepper from "./pages/KundenDashboard/KundenStepper/KundenStepper";
import KundenDetail from "./pages/KundenDetails/KundenDetails";
import EditKundenMachines from "./pages/KundenDetails/EditKundenMachines";
import EditKundenUsersPage from "./pages/KundenDetails/EditKundenUsersPage";
import EditKundenStandOrt from "./pages/KundenDetails/EditKundenStandOrt";
import EditDeleteKundenPage from "./pages/KundenDetails/EditDeleteKunden";

const CreateMachineTypePage = React.lazy(() =>
  import("./pages/CreateMachineTypePage/CreateMachineTypePage"),
);

const OpenNotifications = React.lazy(() =>
  import("./pages/DashboardPage/components/OpenNotifications"),
);

const AuthRoute = React.lazy(() => import("./components/AuthRoute"));

const ScopeHeader = React.lazy(() => import("./components/ScopeHeader"));

const LoginPage = React.lazy(() => import("./pages/LoginPage/LoginPage"));
const NewDashboardPage = React.lazy(() =>
  import("./pages/NewDashboardPage/newdashboard"),
);

const MessagesPage = React.lazy(() =>
  import("./pages/MessagesPage/MessagesPage"),
);
const EditNotificationPage = React.lazy(() =>
  import("./pages/EditNotificationPage/EditNotificationPage"),
);
const AddUserPage = React.lazy(() => import("./pages/AddUserPage/AddUserPage"));
const AdminPage = React.lazy(() => import("./pages/AdminPage/AdminPage"));
const MachinesPage = React.lazy(() =>
  import("./pages/MachinesPage/MachinesPage"),
);

const SitePage = React.lazy(() => import("./pages/SitePage/SitePage"));
const CreateSitePage = React.lazy(() =>
  import("./pages/CreateSitePage/CreateSitePage"),
);

const CreateAreaPage = React.lazy(() =>
  import("./pages/CreateAreaPage/CreateAreaPage"),
);
// const DashboardPage = React.lazy(() => import("./pages/DashboardPage/DashboardPage"))
const SuperUserDashboardPage = React.lazy(() =>
  import("./pages/SuperUserDashboardPage/SuperUserDashboardPage"),
);

const CreateMachinePage = React.lazy(() =>
  import("./pages/CreateMachinePage/CreateMachinePage"),
);
const CreateMachinePoolPage = React.lazy(() =>
  import("./pages/CreateMachinePoolPage/CreateMachinePoolPage"),
);
const KundentrainingPage = React.lazy(() =>
  import("./pages/KundentrainingPage/KundentrainingPage"),
);
const KundentrainingDetailPage = React.lazy(() =>
  import("./pages/KundentrainingPage/KundentrainingDetailPage"),
);

const ClientsPage = React.lazy(() => import("./pages/ClientsPage/ClientsPage"));
const CreateClientPage = React.lazy(() =>
  import("./pages/ClientsPage/CreateClientPage"),
);

const MainLayout = React.lazy(() => import("./components/MainLayout"));

const CreateWorkflowStep = React.lazy(() =>
  import("./pages/WorkFlowSteps/CreateWorkflowStep"),
);

const CreateMaintenanceTask = React.lazy(() =>
  import(
    "./pages/MachineOverviewPage/_tabs/Maintenance/components/CreateMaintenanceTask"
  ),
);
const CreateReport = React.lazy(() => import("./pages/protocol/protocol"));

const NewCreateReport = React.lazy(() =>
  import("./pages/protocol/NewProtocol"),
);

const MaintenanceDashboard = React.lazy(() =>
  import("./pages/MaintenanceDashboard/MaintenanceDashoard"),
);
const SetPassword = React.lazy(() => import("./pages/PaswordPage/SetPassword"));
const ResetPassword = React.lazy(() =>
  import("./pages/PaswordPage/ResetPassword"),
);
const MbDashboard = React.lazy(() => import("./pages/MbDashboard/MbDashboard"));
const MachineTypeOverviewPage = React.lazy(() =>
  import("./pages/MachineTypeOverviewPage/MachineTypeOverviewPage"),
);
const MbAdminOverviewPage = React.lazy(() =>
  import("./pages/MbAdminOverviewPage/MbAdminOverviewPage"),
);
const CreateBrandPage = React.lazy(() =>
  import("./pages/MbAdminOverviewPage/_tabs/Brands/CreateBrandPage"),
);
const CreateEquipmentClassPage = React.lazy(() =>
  import(
    "./pages/MbAdminOverviewPage/_tabs/EquipmentClasses/CreateEquipmentClassPage"
  ),
);
const EquipmentTypesMachinesPage = React.lazy(() =>
  import("./pages/EquipmentTypesMachinesPage/EquipmentTypesMachinesPage"),
);
const Welcome = React.lazy(() => import("./pages/FreeUserWelcomePage/welcome"));
const SiteAreaEqs = React.lazy(() => import("./components/SiteAreaEqs"));
const ExportPage = React.lazy(() => import("./pages/ExportPage/ExportPage"));
const Newcalender = React.lazy(() => import("./pages/Newcalender/Newcalender"));

const TwoFa = React.lazy(() => import("./pages/TwoFa/twoFa"));
const ProductTypesPage = React.lazy(() =>
  import("./pages/ProductTypesPage/ProductTypesPage"),
);
const CreateProductTypePage = React.lazy(() =>
  import("./pages/ProductTypesPage/CreateProductTypePage"),
);

export const socket = io(
  config_UPTIME.url.SOCKET_URL,
  {
    reconnection: true, // whether to reconnect automatically
    reconnectionAttempts: 1, // number of reconnection attempts before giving up
    reconnectionDelay: 1000, // how long to initially wait before attempting a new reconnection
    reconnectionDelayMax: 5000, // maximum amount of time to wait between reconnection attempts. Each attempt increases the reconnection delay by 2x along with a randomization factor
    randomizationFactor: 0.5,
  },
  { transports: ["pooling", "websocket"] },
).connect();

function App() {
  const [autoLogoutFire, setAutoLogoutFire] = useState(false);
  const i18n = useSelector((state) => state.i18n);

  // const navigate = useNavigate()

  useEffect(() => {
    const tabsOpen = getItem("tabsOpen");
    if (tabsOpen == null) {
      setItem("tabsOpen", 1);
    } else {
      setItem("tabsOpen", parseInt(tabsOpen) + parseInt(1));
    }
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  const handleUnload = (event) => {
    const tabsOpen = parseInt(getItem("tabsOpen"));
    if (event.type === "unload") {
      if (tabsOpen == 1 && store.getState().autoLogout === true) {
        if (window.location.port !== "3000") {
          clearLocalStoragePreservingLanguage();
        }
        setItem("tabsOpen", tabsOpen - 1);
      } else {
        setItem("tabsOpen", tabsOpen - 1);
      }
    }
  };

  const getStateAutoLogout = (value) => {
    setAutoLogoutFire(value);
  };

  const refs = Array(6)
    .fill(null)
    .map(() => React.createRef());

  const PageNotFound = () => {
    return (
      <div className="Page404">
        <h2>Page not found 404 </h2>
        <button>
          <Link to={"/dashboard"}> Go to Dashboard </Link>
        </button>
      </div>
    );
  };

  const AccountThemeSync = () => {
    const location = useLocation();

    useEffect(() => {
      const isFette =
        location.pathname === "/fette" ||
        location.pathname.startsWith("/fette/");
      applyAccountTheme(location.pathname);
      document.title = isFette ? "Fette Compacting" : "247Access";

      const iconHref = isFette
        ? `${process.env.PUBLIC_URL}/images/fette-favicon.ico`
        : `${process.env.PUBLIC_URL}/app-branding/favicon-32x32.png`;

      const icon32 = document.getElementById("favicon-32");
      const icon16 = document.getElementById("favicon-16");
      const appleTouch = document.getElementById("apple-touch-icon");

      if (icon32) {
        icon32.setAttribute("href", iconHref);
        icon32.setAttribute("type", isFette ? "image/x-icon" : "image/png");
      }

      if (icon16) {
        icon16.setAttribute(
          "href",
          isFette
            ? `${process.env.PUBLIC_URL}/images/fette-favicon.ico`
            : `${process.env.PUBLIC_URL}/app-branding/favicon-16x16.png`,
        );
        icon16.setAttribute("type", isFette ? "image/x-icon" : "image/png");
      }

      if (appleTouch) {
        appleTouch.setAttribute(
          "href",
          isFette
            ? `${process.env.PUBLIC_URL}/images/fette-favicon.ico`
            : `${process.env.PUBLIC_URL}/app-branding/apple-touch-icon.png`,
        );
      }
    }, [location.pathname]);

    return null;
  };

  const dualRoute = (path, element) => [
    <Route key={path} path={path} element={element} />,
    <Route
      key={`fette:${path}`}
      path={getDualRoutePath(path)}
      element={element}
    />,
  ];

  // render your app here
  return (
    <ThemeProvider theme={Theme247}>
      <CssBaseline />
      <GlobalCss />

      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AccountThemeSync />
        <Routes>
          {dualRoute(
            "/signup",
            <AuthRoute type="guest">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <SignUpPage />
              </MainLayout>
            </AuthRoute>,
          )}
          {dualRoute(
            "/login",
            <AuthRoute type="guest">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <LoginPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/welcome",
            <AuthRoute type="guest">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <Welcome />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/dashboard",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ScopeHeader
                  bgColor="var(--color-primary)"
                  bgImage="../images/access-scope_header.jpg"
                  bgSize="cover"
                  bgPosition="center center"
                  bgRepeat="no-repeat"
                  txtColor="#FFFFFF"
                  title={i18n?.scopeHeader?.dashboardTitle}
                  id="card_dashboard_main"
                  dataTestId="card_dashboard_main"
                  description={i18n?.scopeHeader?.dashboardDescription}
                />
                <SiteAreaEqs />
                <NewDashboardPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/ersatzteile",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ScopeHeader
                  bgColor="var(--color-primary)"
                  bgImage="../images/bg1.jpg"
                  txtColor="#FFFFFF"
                  title={i18n?.scopeHeader?.sparePartsTitle}
                  description={i18n?.scopeHeader?.sparePartsDescription}
                />
                <div
                  style={{ background: "#fff", padding: 24, borderRadius: 4 }}
                >
                  <Typography variant="body1">
                    {i18n?.scopeHeader?.sparePartsPlaceholder}
                  </Typography>
                </div>
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/schulungen"
            element={<Navigate to="/kundentraining" replace={true} />}
          />
          <Route
            path="/fette/schulungen"
            element={<Navigate to="/fette/kundentraining" replace={true} />}
          />

          {dualRoute(
            "/kundentraining",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ScopeHeader
                  bgColor="var(--color-primary)"
                  bgImage="../images/csm_training_header_e2d7e196d4.jpg"
                  bgSize="cover"
                  bgPosition="center center"
                  bgRepeat="no-repeat"
                  txtColor="#FFFFFF"
                  title={i18n?.scopeHeader?.customerTrainingsTitle}
                  description={i18n?.scopeHeader?.customerTrainingsDescription}
                />
                <KundentrainingPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/kundentraining/:moduleId",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <KundentrainingDetailPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/kunden-dashboard",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ScopeHeader
                  bgColor="var(--color-primary)"
                  bgImage="../images/bg1.webp"
                  txtColor="#FFFFFF"
                  title={i18n?.scopeHeader?.customersTitle}
                  id="card_kunden_dashboard_main"
                  dataTestId="card_kunden_dashboard_main"
                  description={i18n?.scopeHeader?.customersDescription}
                />
                <KundenDashboard />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/kunden-detail",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <KundenDetail />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/new-kunden",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <KundenStepper />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/edit-kunden-machines",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <EditKundenMachines />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/edit-kunden-users",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <EditKundenUsersPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/edit-kunden-locations",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <EditKundenStandOrt />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/edit-kunden",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <EditDeleteKundenPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/kunden-portal",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ScopeHeader
                  bgColor="var(--color-primary)"
                  bgImage="../images/bg1.webp"
                  txtColor="#FFFFFF"
                  title={i18n?.scopeHeader?.customerPortalsTitle}
                  id="card_kunden_portal_main"
                  dataTestId="card_kunden_portal_main"
                  description={i18n?.scopeHeader?.customerPortalsDescription}
                />
                <KundenPortal />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/produkttypen",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ScopeHeader
                  bgColor="var(--color-primary)"
                  bgImage="../images/bg1.webp"
                  txtColor="#FFFFFF"
                  title={i18n?.scopeHeader?.productTypesTitle}
                  description={i18n?.scopeHeader?.productTypesDescription}
                  showCloseIcon
                />
                <ProductTypesPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/view-produkttyp/:nodeId",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <CreateProductTypePage />
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/initial-state"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  {/* <ScopeHeader bgColor="var(--color-primary)" bgImage="../images/bg1.webp" txtColor="#FFFFFF" title="Dashboard" description="Das Dashboard zeigt Ihnen auf, welche Ihrer Maschinen Auffälligkeiten aufweien, damit Sie umgehend darauf reagieren können." /> */}

                  {/* <SiteAreaEqs /> */}
                  <InitialState />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/machines"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    linearGradient="rgba(0, 0, 0, 0.4)"
                    bgImage="../images/bg5.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.equipmentTitle}
                    description={i18n?.scopeHeader?.equipmentDescription}
                  />

                  <SiteAreaEqs />
                  <MachinesPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          {dualRoute(
            "/create-machine",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                {/* <CreateMachinePage /> */}
                <CreateEquipment />
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/edit-machine"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateMachinePage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-machine-pool"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateMachinePoolPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-machine-pool"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateMachinePoolPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          {dualRoute(
            "/edit-notification",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <EditNotificationPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/create-notification",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <EditNotificationPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/profile",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <ProfilePage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/users",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <Users />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/messages",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <MessagesPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/add-user",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <AddUserPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/edit-user",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <AddUserPage />
              </MainLayout>
            </AuthRoute>,
          )}

          {dualRoute(
            "/machine-overview",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <MachineOverviewPage />
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/export"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg1.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.exportTitle}
                    description={i18n?.scopeHeader?.exportDescription}
                  />
                  <ExportPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-site"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateSite />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-area"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateArea />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-equipment"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateEquipment />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-equipment-pool"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateEquipmentPool />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/notifications-dashboard"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg6.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.openNotificationsTitle}
                    description={
                      i18n?.scopeHeader?.openNotificationsDescription
                    }
                  />

                  <OpenNotifications />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/super"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <SuperUserDashboardPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          {dualRoute(
            "/notification-details",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <NotificationDetailsPage />
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/admin"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <AdminPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            exact
            path="/sites"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg12.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.sitesTitle}
                    description={i18n?.scopeHeader?.sitesDescription}
                  />

                  <SitePage />
                </MainLayout>
              </AuthRoute>
            }
          />
          <Route
            path="/sites/:no_sites"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg12.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.sitesTitle}
                    description={i18n?.scopeHeader?.sitesDescription}
                  />

                  <SitePage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-site"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateSitePage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-site"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <SitePage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-pool"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateSitePage />
                </MainLayout>
              </AuthRoute>
            }
          />

          {/* <Route path="/edit-area" element={
            <AuthRoute type="private" >
              <MainLayout getStateAutoLogout={getStateAutoLogout} >
                <SitePage />
              </MainLayout>
            </AuthRoute>
          }
          /> */}

          <Route
            path="/clients"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ClientsPage />
                </MainLayout>
              </AuthRoute>
            }
          />
          <Route
            path="/create-client"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateClientPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          {dualRoute(
            "/create-workflow-step",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <CreateWorkflowStep />
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/edit-workflow-step"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateWorkflowStep />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-faq"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateWorkflowStep />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-faq"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateWorkflowStep />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-maintenance-task"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateMaintenanceTask />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-maintenance-task"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateMaintenanceTask />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/template-skeliton"
            element={
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <TemplateSkeliton />
              </MainLayout>
            }
          />

          <Route
            path="/create-report"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateReport />
                </MainLayout>
              </AuthRoute>
            }
          />

          {/* <Route
            path="/create-new-report"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <NewCreateReport />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-new-report"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <NewCreateReport />
                </MainLayout>
              </AuthRoute>
            }
          /> */}

          <Route
            path="/edit-report"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateReport />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/maintenance-dashboard"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg9.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.maintenanceTitle}
                    description={i18n?.scopeHeader?.maintenanceDescription}
                  />
                  <SiteAreaEqs />
                  <Newcalender />
                  {/*  <MaintenanceDashboard /> */}
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/aufgabeplanung"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg2.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.taskPlanningTitle}
                    description={i18n?.scopeHeader?.taskPlanningDescription}
                  />
                  <AufgabePlanung />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/new-calender"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <SiteAreaEqs />
                  <Newcalender />
                </MainLayout>
              </AuthRoute>
            }
          />

          {dualRoute(
            "/2fa",
            <AuthRoute type="private">
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <TwoFa refs={refs.current} />
              </MainLayout>
            </AuthRoute>,
          )}

          <Route
            path="/mb-dashboard"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <MbDashboard />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/equipmenttype-overview"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <MachineTypeOverviewPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-equipmenttype"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateMachineTypePage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/mb-admin"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <MbAdminOverviewPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-brand"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateBrandPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-brand"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateBrandPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-equipment-class"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateEquipmentClassPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-equipment-class"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <CreateEquipmentClassPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          <Route
            path="/types-machines"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <EquipmentTypesMachinesPage />
                </MainLayout>
              </AuthRoute>
            }
          />

          {dualRoute(
            "/set-password/:token",
            <MainLayout>
              <SetPassword />
            </MainLayout>,
          )}

          {dualRoute(
            "/reset-password",
            <MainLayout getStateAutoLogout={getStateAutoLogout}>
              <ResetPassword />
            </MainLayout>,
          )}

          <Route
            path="/OrderSubscription"
            element={
              <AuthRoute type="private">
                <OrderSubscriptionPage />
              </AuthRoute>
            }
          />
          <Route
            path="/HelpAndFeedbackPage"
            element={
              <AuthRoute type="private">
                <MainLayout getStateAutoLogout={getStateAutoLogout}>
                  <ScopeHeader
                    bgColor="var(--color-primary)"
                    bgImage="../images/bg9.webp"
                    txtColor="#FFFFFF"
                    title={i18n?.scopeHeader?.helpFeedbackTitle}
                    description={i18n?.scopeHeader?.helpFeedbackDescription}
                  />
                  <HelpAndFeedbackPage />
                </MainLayout>{" "}
              </AuthRoute>
            }
          />

          {/* <Route
            path="/OrderSubscriptionstep2"
            element={
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <OrderSubscriptionStep2 />
              </MainLayout>
            }
          />
          <Route
            path="/OrderSubscriptionstep3"
            element={
              <MainLayout getStateAutoLogout={getStateAutoLogout}>
                <OrderSubscriptionStep3 />
              </MainLayout>
            }
          /> */}
          <Route path="/" element={<Navigate to="/login" replace={true} />} />
          <Route
            path="/fette"
            element={<Navigate to="/fette/login" replace={true} />}
          />
          {/* <Route
            index 
            path="/"
            element={<Navigate to="/signup" replace={true} />}
          /> */}
          <Route exact path="/fette/*" element={<PageNotFound />} />
          <Route exact path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

const UptimeWeb = () => {
  return (
    <Provider store={store}>
      <Suspense fallback={<div>loading...</div>}>
        <App />
      </Suspense>
    </Provider>
  );
};

export default UptimeWeb;
